// Days of cover by a weekly forecast — Shipments Planning, Days Supplied / Forecast AI.
// No React. Week keys are ISO, 'YYYY-Www', as the AI agent sends them (yoy_forecast_history).
import { getISOWeek, getISOWeekYear } from 'date-fns';

// ISO weeks starting with the one `today` is in: [{ key: '2026-W40', days }].
// days = 7, except the first week — only what is left of it, today included.
export const weeksAhead = (today = new Date(), count = 53) => {
  const d = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const weeks = [];
  let days = 7 - (d.getDay() + 6) % 7; // Mon → 7 … Sun → 1
  for (let i = 0; i < count; i++) {
    weeks.push({ key: `${getISOWeekYear(d)}-W${String(getISOWeek(d)).padStart(2, '0')}`, days });
    d.setDate(d.getDate() + days); // next Monday
    days = 7;
  }
  return weeks;
};

// How many days `stock` lasts if sales follow `weekly` { 'YYYY-Www': units | { value } }.
// Weeks the stock covers are consumed whole; the rest of the current week and the week
// the stock runs out in go by that week's daily rate (units / 7).
// → { days, beyond }: beyond = the forecast ended before the stock did, so days is the
//   forecast horizon, not the real cover. null = no forecast for the current week.
export const daysByWeeklyForecast = (stock, weekly, weeks) => {
  let left = Math.max(0, Number(stock) || 0), days = 0;
  for (const w of weeks) {
    const v = weekly?.[w.key];
    const units = v && typeof v === 'object' ? v.value : v;
    if (units == null || !isFinite(Number(units))) return days ? { days, beyond: true } : null;
    const need = Math.max(0, Number(units)) * w.days / 7;
    if (left <= need) return { days: days + (need ? left / need * w.days : 0), beyond: false };
    left -= need;
    days += w.days;
  }
  return { days, beyond: true };
};
